import React from 'react';

import {CL_RX_METHOD} from 'constants/success';

import {EyeExam} from '../eyeExam/eyeExam';
import {ManualDoctorWrapper} from '../manualDoctorWrapper/manualDoctorWrapper';
import {SmartDoctor} from '../smartDoctor/smartDoctor';
import {UploadPrescription} from '../uploadPrescription/uploadPrescription';
import {VisiblyExamWrapper} from '../visiblyExam/visiblyExam';
import {VisiblyExamFailWrapper} from '../visiblyExamFailWrapper/visiblyExamFailWrapper';

/**
 * Methods for popup
 */
export const METHODS = {
    [CL_RX_METHOD.DOCTOR]: <SmartDoctor />,
    [CL_RX_METHOD.EYE_EXAM]: <EyeExam />,
    [CL_RX_METHOD.EYE_EXAM_ELIGIBILITY]: <VisiblyExamWrapper />,
    [CL_RX_METHOD.EYE_EXAM_ELIGIBILITY_FAILED]: <VisiblyExamFailWrapper />,
    [CL_RX_METHOD.MANUALLY_DOCTOR]: <ManualDoctorWrapper />,
    [CL_RX_METHOD.UPLOAD]: <UploadPrescription />,
};
